export default __webpack_public_path__ + "static/media/needImg1.acad9264.png";